import React, { useEffect, useState } from "react";
import "./header.css";
import Navbar from "../navbar/Navbar";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const fullText = "Top Website Design Company to Boost Your Online Presence";
  const [displayedText, setDisplayedText] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Typing animation
  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setDisplayedText(fullText.slice(0, index + 1));
      index++;
      if (index === fullText.length) clearInterval(interval);
    }, 100);

    return () => clearInterval(interval);
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Send to WhatsApp
  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, message } = formData;
    const phoneNumber = "918778934301"; // use country code (91 for India)

    const text = `Hello Electiaa Team,%0A%0A
*Name:* ${name}%0A
*Email:* ${email}%0A
*Phone:* ${phone}%0A
*Message:* ${message}%0A%0A
Please get in touch with me regarding website design services.`;

    // Open WhatsApp chat with pre-filled message
    window.open(`https://wa.me/${phoneNumber}?text=${text}`, "_blank");
  };

  return (
    <header className="header-section">
      <div className="overlay"></div>
      <Navbar scrolled={scrolled} />

      <div className="header-container">
        {/* Left Content */}
        <div className="header-content">
          <h3 className="heading-text1">
            Electiaa – Web Design, Marketing & Branding Experts in Chennai
          </h3>

          <h1 className="main-heading">{displayedText}</h1>

          <ul className="sub-text">
            <li>200+ Businesses Trusted Electiaa Company</li>
            <li>To Build Their Websites & Digital Marketing</li>
          </ul>

          <h4 className="features-heading">Website Features For</h4>
          <p className="features-sub">
            <span className="highlight">Business Website</span> &{" "}
            <span className="highlight">E-Commerce Website</span>
          </p>

          {/* <button className="choose-plan-btn">Get Pricing Details</button> */}
          <button
            className="choose-plan-btn"
            onClick={() => {
              const section = document.getElementById("services");
              if (section) {
                section.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Get Pricing Details
          </button>

        </div>

        {/* Right Form */}
        <div className="header-form">
          <h3>Get in Touch</h3>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button className="choose-plan-btn" type="submit">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </header>
  );
}

export default Header;
